class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);
    this.onMobileFacetsWrapperClick = this.onMobileFacetsWrapperClick.bind(this);
    this.onPriceRangeLinkClick = this.onPriceRangeLinkClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 300);

    const facetForm = this.querySelector('form');
    facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));

    const wrapper = this.closest('.mobile-facets__wrapper');
    if (wrapper) {
      wrapper.addEventListener('click', this.onMobileFacetsWrapperClick, true);
    }

    this.addEventListener('click', this.onPriceRangeLinkClick);

    this.querySelectorAll('form').forEach((form) => {
      form.addEventListener('submit', (e) => {
        if (e.target.id === 'FacetFiltersFormMobile') {
          e.preventDefault();
          const { searchParams, hasKeyword } = this.createSearchParamsForSearchRedirect(e.target);
          const wrapper = e.target.closest('.mobile-facets__wrapper');
          const summary = wrapper?.querySelector('summary');

          if (!hasKeyword) {
            const basePath = window.location.pathname;
            if (this.isSameFilterState(window.location.pathname, window.location.search, basePath, searchParams)) {
              if (summary) summary.click();
              return;
            }
            FacetFiltersForm.toggleActiveFacets(true);
            this.onSubmitForm(this.createSearchParams(e.target), e);
            if (summary) summary.click();
            return;
          }

          const redirectUrl = (e.target.dataset.searchResultsUrl || '/search') + (searchParams ? '?' + searchParams : '');
          window.location.href = redirectUrl;
        }
      });
    });

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);
  }

  closeAccordionFilters() {
    const desktop = document.querySelector('#FacetsWrapperDesktop');
    let list = desktop ? Array.from(desktop.querySelectorAll('details')) : Array.from(document.querySelectorAll('details[id*="custom.scene"], details[id*="custom.concern"]'));
    const mobile = document.querySelector('#FacetsWrapperMobile');
    if (mobile) list = list.concat(Array.from(mobile.querySelectorAll('.mobile-facets__details')));
    list.forEach((el) => {
      const id = el.getAttribute('id') || '';
      const close = el.hasAttribute('data-accordion-initial-closed') || id.includes('custom.scene') || id.includes('custom.concern');
      if (close) {
        el.removeAttribute('open');
        const s = el.querySelector('summary');
        if (s) s.setAttribute('aria-expanded', 'false');
      }
    });
  }

  connectedCallback() {
    this.closeAccordionFilters();
    setTimeout(() => this.closeAccordionFilters(), 200);
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }
  static syncPriceRangeActiveState() {
    const lists = document.querySelectorAll('.facets__list--price-range');
    if (!lists.length) return;

    const params = new URLSearchParams(window.location.search);
    const gte = params.get('filter.v.price.gte');
    const lte = params.get('filter.v.price.lte');
    const minVal = gte ? Number(gte) : 0;
    const maxVal = lte ? Number(lte) : null;

    lists.forEach((list) => {
      const items = list.querySelectorAll('.facets__item');
      if (!items.length) return;

      items.forEach((item) => {
        item.classList.remove('facets__item--selected');
        const label = item.querySelector('.facets__label');
        if (label) {
          label.classList.remove('active', 'facets__label--selected');
        }
      });

      if (!gte && !lte) return;

      items.forEach((item) => {
        const itemMin = Number(item.dataset.priceMin || 0);
        const itemMaxRaw = item.dataset.priceMax;
        const itemMax = itemMaxRaw === undefined || itemMaxRaw === null || itemMaxRaw === '' ? null : Number(itemMaxRaw);

        const isMatch =
          itemMin === minVal &&
          ((maxVal === null && itemMax === null) || (maxVal !== null && itemMax === maxVal));

        if (!isMatch) return;

        item.classList.add('facets__item--selected');
        const label = item.querySelector('.facets__label');
        if (label) {
          label.classList.add('active', 'facets__label--selected');
        }
      });
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    const loadingSpinners = document.querySelectorAll(
      '.facets-container .loading__spinner, facet-filters-form .loading__spinner'
    );
    loadingSpinners.forEach((spinner) => spinner.classList.remove('hidden'));
    const gridContainer = document.getElementById('ProductGridContainer');
    const collectionEl = gridContainer?.querySelector('.collection');
    if (collectionEl) collectionEl.classList.add('loading');
    if (countContainer) countContainer.classList.add('loading');
    if (countContainerDesktop) countContainerDesktop.classList.add('loading');

    const MAX_CACHE = 15;
    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const cached = FacetFiltersForm.filterData.get(url);
      if (cached) {
        FacetFiltersForm.renderSectionFromCache(url, event);
      } else {
        FacetFiltersForm.renderSectionFromFetch(url, event, MAX_CACHE);
      }
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static applySectionResponse(parsed, event) {
    FacetFiltersForm.renderFilters(parsed, event);
    FacetFiltersForm.renderProductGridContainer(parsed);
    FacetFiltersForm.renderProductCount(parsed);
    FacetFiltersForm.renderCountBar(parsed);
    document.querySelectorAll('facet-filters-form').forEach((form) => {
      if (typeof form.closeAccordionFilters === 'function') form.closeAccordionFilters();
    });
    FacetFiltersForm.deferScrollAnimationInit();
    FacetFiltersForm.syncPriceRangeActiveState();
  }

  static renderSectionFromFetch(url, event, maxCache = 15) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const cache = FacetFiltersForm.filterData;
        if (cache.size >= maxCache) {
          const firstKey = cache.keys().next().value;
          if (firstKey != null) cache.delete(firstKey);
        }
        cache.set(url, { html: responseText, url });
        const parsed = new DOMParser().parseFromString(responseText, 'text/html');
        FacetFiltersForm.applySectionResponse(parsed, event);
      });
  }

  static renderSectionFromCache(url, event) {
    const cached = FacetFiltersForm.filterData.get(url);
    if (!cached) return;
    const parsed = new DOMParser().parseFromString(cached.html, 'text/html');
    FacetFiltersForm.applySectionResponse(parsed, event);
  }

  static deferScrollAnimationInit() {
    const run = () => {
      if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(document);
    };
    if (typeof requestIdleCallback !== 'undefined') {
      requestIdleCallback(run, { timeout: 200 });
    } else {
      setTimeout(run, 0);
    }
  }

  static renderProductGridContainer(parsedDoc) {
    const source = parsedDoc.getElementById('ProductGridContainer');
    const container = document.getElementById('ProductGridContainer');
    if (!source || !container) return;
    container.innerHTML = source.innerHTML;
    container.querySelectorAll('.scroll-trigger').forEach((element) => {
      element.classList.add('scroll-trigger--cancel');
    });
  }

  static renderProductCount(parsedDoc) {
    const countEl = parsedDoc.getElementById('ProductCount');
    const count = countEl ? countEl.innerHTML : '';
    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');
    container.innerHTML = count;
    container.classList.remove('loading');
    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove('loading');
    }
    const loadingSpinners = document.querySelectorAll(
      '.facets-container .loading__spinner, facet-filters-form .loading__spinner'
    );
    loadingSpinners.forEach((spinner) => spinner.classList.add('hidden'));
  }

  /** 件数表示バー（custom-count-bar）を取得HTMLで差し替え。ProductGridContainer 外のため別途更新 */
  static renderCountBar(parsedDoc) {
    const sourceBars = parsedDoc.querySelectorAll('[data-count-bar]');
    const targetBars = document.querySelectorAll('.count-bar-and-grid-wrapper [data-count-bar]');
    if (sourceBars.length === 0 || sourceBars.length !== targetBars.length) return;
    sourceBars.forEach((source, i) => {
      if (targetBars[i]) targetBars[i].outerHTML = source.outerHTML;
    });
    if (typeof window.initCountBars === 'function') window.initCountBars();
  }

  static renderFilters(parsedHTML, event) {
    const facetDetailsElementsFromFetch = parsedHTML.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );
    const facetDetailsElementsFromDom = document.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );
    const fetchIds = new Set(Array.from(facetDetailsElementsFromFetch, (el) => el.id));

    // Remove facets that are no longer returned from the server
    Array.from(facetDetailsElementsFromDom).forEach((currentElement) => {
      if (!fetchIds.has(currentElement.id)) currentElement.remove();
    });

    const matchesId = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.id === jsFilter.id : false;
    };

    const facetsToRender = Array.from(facetDetailsElementsFromFetch).filter((element) => !matchesId(element));
    const countsToRender = Array.from(facetDetailsElementsFromFetch).find(matchesId);

    facetsToRender.forEach((elementToRender, index) => {
      const currentElement = document.getElementById(elementToRender.id);
      // Element already rendered in the DOM so just update the innerHTML
      if (currentElement) {
        document.getElementById(elementToRender.id).innerHTML = elementToRender.innerHTML;
      } else {
        if (index > 0) {
          const { className: previousElementClassName, id: previousElementId } = facetsToRender[index - 1];
          // Same facet type (eg horizontal/vertical or drawer/mobile)
          if (elementToRender.className === previousElementClassName) {
            document.getElementById(previousElementId).after(elementToRender);
            return;
          }
        }

        if (elementToRender.parentElement) {
          document.querySelector(`#${elementToRender.parentElement.id} .js-filter`).before(elementToRender);
        }
      }
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) {
      const closestJSFilterID = event.target.closest('.js-filter').id;

      if (closestJSFilterID) {
        FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
        FacetFiltersForm.renderMobileCounts(countsToRender, document.getElementById(closestJSFilterID));

        const newFacetDetailsElement = document.getElementById(closestJSFilterID);
        const newElementSelector = newFacetDetailsElement.classList.contains('mobile-facets__details')
          ? `.mobile-facets__close-button`
          : `.facets__summary`;
        const newElementToActivate = newFacetDetailsElement.querySelector(newElementSelector);

        const isTextInput = event.target.getAttribute('type') === 'text';

        if (newElementToActivate && !isTextInput) newElementToActivate.focus();
      }
    }
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = [
      '.mobile-facets__open',
      '.mobile-facets__count',
      '.sorting',
      '#FacetsWrapperMobile > .mobile-facets__footer'
    ];

    mobileElementSelectors.forEach((selector) => {
      const sourceEl = html.querySelector(selector);
      const targetEl = document.querySelector(selector);
      if (!sourceEl || !targetEl) return;
      targetEl.innerHTML = sourceEl.innerHTML;
    });

    document.getElementById('FacetFiltersFormMobile').closest('menu-drawer').bindEvents();
  }

  static renderCounts(source, target) {
    const targetSummary = target.querySelector('.facets__summary');
    const sourceSummary = source.querySelector('.facets__summary');

    if (sourceSummary && targetSummary) {
      targetSummary.outerHTML = sourceSummary.outerHTML;
    }

    const targetHeaderElement = target.querySelector('.facets__header');
    const sourceHeaderElement = source.querySelector('.facets__header');

    if (sourceHeaderElement && targetHeaderElement) {
      targetHeaderElement.outerHTML = sourceHeaderElement.outerHTML;
    }

    const targetWrapElement = target.querySelector('.facets-wrap');
    const sourceWrapElement = source.querySelector('.facets-wrap');

    if (sourceWrapElement && targetWrapElement) {
      const isShowingMore = Boolean(target.querySelector('show-more-button .label-show-more.hidden'));
      if (isShowingMore) {
        sourceWrapElement
          .querySelectorAll('.facets__item.hidden')
          .forEach((hiddenItem) => hiddenItem.classList.replace('hidden', 'show-more-item'));
      }

      targetWrapElement.outerHTML = sourceWrapElement.outerHTML;
    }
  }

  static renderMobileCounts(source, target) {
    const targetFacetsList = target.querySelector('.mobile-facets__list');
    const sourceFacetsList = source.querySelector('.mobile-facets__list');

    if (sourceFacetsList && targetFacetsList) {
      targetFacetsList.outerHTML = sourceFacetsList.outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      },
    ];
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    const searchParams = new URLSearchParams(formData);

    if (form.id === 'FacetFiltersForm' || form.id === 'FacetFiltersFormMobile') {
      const current = new URLSearchParams(window.location.search);
      ['filter.v.price.gte', 'filter.v.price.lte'].forEach((key) => {
        if (current.has(key) && !searchParams.has(key)) {
          searchParams.set(key, current.get(key));
        }
      });
    }

    return searchParams.toString();
  }

  /**
   * クエリの順序を無視して、同じフィルタ状態かどうか判定する（キーワードなし時の二重リロード防止用）
   */
  isSameFilterState(currentPath, currentSearch, targetPath, targetSearch) {
    if (currentPath !== targetPath) return false;
    const norm = (s) => {
      const p = new URLSearchParams(s || '');
      return [...p.entries()].sort((a, b) => a[0].localeCompare(b[0])).map(([k, v]) => `${k}=${v}`).join('&');
    };
    return norm(currentSearch) === norm(targetSearch);
  }

  /**
   * 検索結果ページ（/search）へのリダイレクト用に、キーワード・フィルタ・並び順を確実に含めたクエリを組み立てる。
   * キーワードがない場合は検索ページでは結果が出ないため、hasKeyword で分岐して遷移先を変える。
   */
  createSearchParamsForSearchRedirect(form) {
    const params = new URLSearchParams();
    const keywordInput = form.querySelector('.mobile-facets__keyword-input');
    const keyword = keywordInput && keywordInput.name === 'q' ? keywordInput.value.trim() : '';
    const hasKeyword = keyword !== '';

    if (hasKeyword) {
      params.set('q', keyword);
      params.set('options[prefix]', 'last');
    }

    const sortSelect = form.querySelector('select[name="sort_by"]');
    if (sortSelect && sortSelect.value) {
      params.set('sort_by', sortSelect.value);
    }

    const filterInputs = form.querySelectorAll('input[name^="filter."], select[name^="filter."]');
    filterInputs.forEach((input) => {
      if (input.type === 'checkbox' || input.type === 'radio') {
        if (input.checked) params.append(input.name, input.value);
      } else if (input.value !== '' && input.value != null) {
        params.set(input.name, input.value);
      }
    });

    document.querySelectorAll(`input[form="${form.id}"][name^="filter."]`).forEach((input) => {
      if (form.contains(input)) return;
      if (input.type === 'checkbox' || input.type === 'radio') {
        if (input.checked) params.append(input.name, input.value);
      } else if (input.value !== '' && input.value != null) {
        params.set(input.name, input.value);
      }
    });

    // 価格フィルタはリンクで操作しているため、現在のURLに付いている条件を必ず引き継ぐ
    const current = new URLSearchParams(window.location.search);
    ['filter.v.price.gte', 'filter.v.price.lte'].forEach((key) => {
      if (current.has(key) && !params.has(key)) {
        params.set(key, current.get(key));
      }
    });

    return { searchParams: params.toString(), hasKeyword };
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll('facet-filters-form form');
    if (event.srcElement.className == 'mobile-facets__checkbox') {
      const searchParams = this.createSearchParams(event.target.closest('form'));
      this.onSubmitForm(searchParams, event);
    } else {
      const forms = [];
      const isMobile = event.target.closest('form').id === 'FacetFiltersFormMobile';

      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
            forms.push(this.createSearchParams(form));
          }
        } else if (form.id === 'FacetFiltersFormMobile') {
          forms.push(this.createSearchParams(form));
        }
      });
      this.onSubmitForm(forms.join('&'), event);
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const link = event.target.closest('a');
    if (!link || !link.href) return;
    const href = link.href;
    const queryIndex = href.indexOf('?');
    const url = queryIndex === -1 ? '' : href.slice(queryIndex + 1);
    FacetFiltersForm.renderPage(url, null, true);
  }

  /**
   * 絞り込みモーダル内リンクをインターセプトして、遷移させずにAJAX更新する。
   */
  onMobileFacetsWrapperClick(event) {
    const link = event.target.closest('a');
    if (!link || !link.href) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    try {
      const linkUrl = new URL(link.href, window.location.origin);
      const queryString = linkUrl.search ? linkUrl.search.slice(1) : '';
      const wrapper = this.closest('.mobile-facets__wrapper');
      const summary = wrapper?.querySelector('details summary');
      const form = document.getElementById('FacetFiltersFormMobile');
      const isClearButton = link.classList.contains('mobile-facets__clear');
      const isPriceRangeLink =
        !!link.closest('.mobile-facets__list--price-range');

      if (isClearButton && form) {
        const keywordInput = form.querySelector('.mobile-facets__keyword-input');
        if (keywordInput) keywordInput.value = '';
        form.querySelectorAll('input[name^="filter."]').forEach((input) => {
          if (input.type === 'checkbox' || input.type === 'radio') input.checked = false;
          else input.value = '';
        });
        document.querySelectorAll(`input[form="${form.id}"][name^="filter."]`).forEach((input) => {
          if (input.type === 'checkbox' || input.type === 'radio') input.checked = false;
          else input.value = '';
        });
        FacetFiltersForm.toggleActiveFacets(true);
        FacetFiltersForm.renderPage(queryString, null, true);
        return;
      }

      const current = window.location.pathname + window.location.search;
      const target = linkUrl.pathname + linkUrl.search;
      if (current !== target) {
        FacetFiltersForm.toggleActiveFacets(true);
        FacetFiltersForm.renderPage(queryString, null, true);
      }
      if (!isPriceRangeLink && summary) summary.click();
    } catch (_) {}
  }

  onPriceRangeLinkClick(event) {
    const link = event.target.closest('.facets__list--price-range a');
    if (!link || !link.href) return;
    event.preventDefault();
    try {
      const item = link.closest('.facets__item');
      const list = link.closest('.facets__list--price-range');
      const isActive = item && item.classList.contains('facets__item--selected');
      let queryString;

      if (isActive) {
        // いったんクライアント側の選択状態を全てリセット
        if (list) {
          list.querySelectorAll('.facets__item').forEach((li) => {
            li.classList.remove('facets__item--selected');
            const label = li.querySelector('.facets__label');
            if (label) {
              label.classList.remove('active', 'facets__label--selected');
            }
          });
        }

        const current = new URLSearchParams(window.location.search);
        current.delete('filter.v.price.gte');
        current.delete('filter.v.price.lte');
        queryString = current.toString();
      } else {
        const url = new URL(link.href, window.location.origin);
        queryString = url.search ? url.search.slice(1) : '';
      }

      FacetFiltersForm.toggleActiveFacets(true);
      FacetFiltersForm.renderPage(queryString, null, true);
    } catch (_) {}
  }
}

FacetFiltersForm.filterData = new Map();
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();
FacetFiltersForm.syncPriceRangeActiveState();

const PRICE_RANGE_KEY_PATTERN = /[0-9]|\.|,|'| |Tab|Backspace|Enter|ArrowUp|ArrowDown|ArrowLeft|ArrowRight|Delete|Escape/;

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input').forEach((element) => {
      element.addEventListener('change', this.onRangeChange.bind(this));
      element.addEventListener('keydown', this.onKeyDown.bind(this));
    });
    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  onKeyDown(event) {
    if (event.metaKey) return;
    if (!PRICE_RANGE_KEY_PATTERN.test(event.key)) event.preventDefault();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('data-max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('data-min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('data-min', 0);
    if (maxInput.value === '') minInput.setAttribute('data-max', maxInput.getAttribute('data-max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('data-min'));
    const max = Number(input.getAttribute('data-max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);
  }
}

customElements.define('facet-remove', FacetRemove);
